import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "diamond-info" }
const _hoisted_2 = { class: "flex items-center gap-4 mb-6" }
const _hoisted_3 = { class: "text-2xl font-serif text-gray-900" }
const _hoisted_4 = { class: "text-xs text-gray-400" }
const _hoisted_5 = { class: "space-y-4" }
const _hoisted_6 = { class: "border-t border-gray-100 pt-4" }
const _hoisted_7 = { class: "flex justify-between items-center group cursor-pointer py-2" }
const _hoisted_8 = { class: "text-xs font-bold uppercase tracking-wider" }
const _hoisted_9 = { class: "flex items-center gap-2" }
const _hoisted_10 = { class: "text-sm text-gray-600" }
const _hoisted_11 = { class: "border-t border-gray-100 pt-2" }
const _hoisted_12 = { class: "flex justify-between items-center group cursor-pointer py-2" }
const _hoisted_13 = { class: "text-xs font-bold uppercase tracking-wider" }
const _hoisted_14 = { class: "flex items-center gap-2" }
const _hoisted_15 = { class: "text-sm text-gray-600" }
const _hoisted_16 = { class: "border-t border-gray-100 pt-2" }
const _hoisted_17 = { class: "flex justify-between items-center group cursor-pointer py-2" }
const _hoisted_18 = { class: "text-xs font-bold uppercase tracking-wider" }
const _hoisted_19 = { class: "flex items-center gap-2" }
const _hoisted_20 = { class: "text-sm text-gray-600" }
const _hoisted_21 = { class: "border-t border-gray-100 pt-2" }
const _hoisted_22 = { class: "flex justify-between items-center group cursor-pointer py-2" }
const _hoisted_23 = { class: "text-xs font-bold uppercase tracking-wider" }
const _hoisted_24 = { class: "flex items-center gap-2" }
const _hoisted_25 = { class: "text-sm text-gray-600" }
const _hoisted_26 = { class: "border-t border-gray-100 pt-2" }
const _hoisted_27 = { class: "flex justify-between items-center group cursor-pointer py-2" }
const _hoisted_28 = { class: "text-xs font-bold uppercase tracking-wider" }
const _hoisted_29 = { class: "flex items-center gap-2" }
const _hoisted_30 = { class: "text-sm text-gray-600" }
const _hoisted_31 = { class: "border-t border-gray-100 pt-2" }
const _hoisted_32 = { class: "flex justify-between items-center group cursor-pointer py-2" }
const _hoisted_33 = { class: "text-xs font-bold uppercase tracking-wider" }
const _hoisted_34 = { class: "flex items-center gap-2" }
const _hoisted_35 = { class: "text-sm text-gray-600" }
const _hoisted_36 = { class: "border-t border-gray-100 pt-2" }
const _hoisted_37 = { class: "flex justify-between items-center group cursor-pointer py-2" }
const _hoisted_38 = { class: "text-xs font-bold uppercase tracking-wider" }
const _hoisted_39 = { class: "flex items-center gap-2" }
const _hoisted_40 = { class: "text-sm text-gray-600" }
const _hoisted_41 = { class: "border-t border-gray-100 pt-2" }
const _hoisted_42 = { class: "flex justify-between items-center group cursor-pointer py-2" }
const _hoisted_43 = { class: "text-xs font-bold uppercase tracking-wider" }
const _hoisted_44 = { class: "flex items-center gap-2" }
const _hoisted_45 = { class: "text-sm text-gray-600" }
const _hoisted_46 = { class: "border-t border-gray-100 pt-2 pb-8" }
const _hoisted_47 = { class: "flex justify-between items-center group cursor-pointer py-2" }
const _hoisted_48 = { class: "text-xs font-bold uppercase tracking-wider" }
const _hoisted_49 = { class: "flex items-center gap-2 justify-center text-gray-600" }
const _hoisted_50 = { class: "text-sm" }
const _hoisted_51 = ["href"]
const _hoisted_52 = { class: "space-y-3 mt-8" }
const _hoisted_53 = {
  key: 2,
  method: "post",
  action: "https://www.rubin-ec84.de:7004/store/faces/login.xhtml",
  target: "_blank"
}
const _hoisted_54 = {
  type: "submit",
  class: "block w-full text-white bg-brand-main p-2 text-center hover:bg-white hover:text-brand-main border border-brand-main text-sm font-light"
}
const _hoisted_55 = ["value"]

import {computed, ref} from "vue";
import { useI18n } from "vue-i18n";
import {SetWidget} from "@/assets/ts/stepWidget";
import {useStore} from "vuex";
import {i18n} from "@/main";
import { Diamond } from '@/store/modules/diamonds'
import {Certificate} from "@/assets/ts/certificate";



export default /*@__PURE__*/_defineComponent({
  __name: 'DiamondInfo',
  props: {
    diamond: {}
  },
  setup(__props: any) {

const props = __props

const { t } = useI18n();

const getFormName = (form: string) => {
  const key = 'components.diamonds.details.form.' + form;
  const translation = t(key);
  return translation !== key ? translation : form;
}

const getPolishName = (polish: string) => {
  const key = 'components.diamonds.details.polish.' + polish;
  const translation = t(key);
  return translation !== key ? translation : polish;
}

const getFluorescenceName = (fluo: string) => {
  const key = 'components.diamonds.details.fluorescence.' + fluo;
  const translation = t(key);
  return translation !== key ? translation : fluo;
}

/**
 *
 */

const createOrderData = (orderType) => {
  let itemNumber = (
      props.diamond.institute + props.diamond.certificate
  ).toUpperCase();

  if (typeof props.diamond.link != "undefined") {
    itemNumber = props.diamond.link.toUpperCase();
  }

  return btoa(
      JSON.stringify({
        fast_order: false,
        order_type: orderType,
        language: "de",
        rings: [
          {
            name: itemNumber,
            size: 0,
            gravure: "",
            gravure_type: 0,
            gravure_outside: "",
            engravingOutsideType: 0,
            item_data: {
              master: [itemNumber],
            },
            master_set: itemNumber,
            itemnumber: itemNumber,
          },
        ],
      })
  );
};

const orderDataDiamond = computed(() => {
  return createOrderData("diamond");
});

const orderDataJewelry = computed(() => {
  return createOrderData("jewelry");
});

const goBack = () => {
  const lastSearch = localStorage.getItem('lastDiamondSearch')
  if (lastSearch) {
    window.location.href = lastSearch
  } else {
    // The main search is the current url without the certificates id
    let path = window.location.pathname
    if (path.endsWith('/')) {
      path = path.slice(0, -1)
    }
    const parts = path.split('/')
    parts.pop()
    window.location.href = parts.join('/') + '/'
  }
}

/**
 * add diamond to conf session
 */

const store = useStore();
const setWidgetApi = new SetWidget();

const isConfSession = ref(setWidgetApi.getConfSession() != null)

const addToConfSession = () => {
  const confSession = setWidgetApi.getConfSession();
  if (!confSession) return;

  store.commit("loading/actionStarted");

  const locale = (i18n.global.locale as any).value || "de-DE";

  let [language, country] = locale.split("-");

  if (locale.split("-").length === 3) {
    language = locale.split("-").splice(0, 2).join("-");
    country = locale.split("-").splice(2, 1).join("-");
  }

  fetch(
      process.env.VUE_APP_API_HOST +
      "/session/" +
      country.toLowerCase() +
      "/" +
      language.toLowerCase() +
      "/" +
      confSession.toLowerCase(),
      {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          item: 0,
          action: "diamond",
          value: props.diamond.link
        }),
      }
  )
      .then((response) => {
        if (response.status === 200) {
          document.location.href = setWidgetApi.createPath("conf");
        }
      })
      .finally(() => {
        store.commit("loading/actionFinished");
      });
};

const openCatalog = () => {
  document.location.href = setWidgetApi.createPath("catalog", props.diamond.link);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.diamond.price.toLocaleString('de-DE')) + " " + _toDisplayString(_ctx.$t('common.currencySymbol')), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('components.itemV2.itemV2Main.incl_vat')), 1),
      _cache[2] || (_cache[2] = _createStaticVNode("<div class=\"flex gap-2 ml-auto text-gray-400\" data-v-a311c138><svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-5 h-5 cursor-pointer hover:text-gray-600\" data-v-a311c138><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M7.217 10.907a2.25 2.25 0 100 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186l9.566-5.314m-9.566 7.5l9.566 5.314m0-10.628a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zm0 10.628a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0z\" data-v-a311c138></path></svg><svg xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" stroke-width=\"1.5\" stroke=\"currentColor\" class=\"w-5 h-5 cursor-pointer hover:text-gray-600\" data-v-a311c138><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z\" data-v-a311c138></path></svg></div>", 1))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('components.diamonds.details.fullSpecs.type')) + ":", 1),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('components.diamonds.details.type.' + __props.diamond.type)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('components.diamonds.details.fullSpecs.form')) + ":", 1),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(getFormName(__props.diamond.form)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('components.diamonds.details.fullSpecs.size')) + ":", 1),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("span", _hoisted_20, _toDisplayString(__props.diamond.size.toLocaleString('de-DE')) + " " + _toDisplayString(_ctx.$t('components.diamonds.details.carat.unit')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('components.diamonds.details.fullSpecs.color')) + ":", 1),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("span", _hoisted_25, _toDisplayString(__props.diamond.color) + " " + _toDisplayString(__props.diamond.fancy_intensity && __props.diamond.colored ? `(${__props.diamond.fancy_intensity})` : ''), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t('components.diamonds.details.fullSpecs.clarity')) + ":", 1),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("span", _hoisted_30, _toDisplayString(__props.diamond.clarity), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('components.diamonds.details.fullSpecs.polishSymmetry')) + ":", 1),
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("span", _hoisted_35, _toDisplayString(getPolishName(__props.diamond.polish)) + " / " + _toDisplayString(getPolishName(__props.diamond.symmetry)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.$t('components.diamonds.details.fullSpecs.fluorescence')) + ":", 1),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("span", _hoisted_40, _toDisplayString(getFluorescenceName(__props.diamond.fluorescence)), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_41, [
        _createElementVNode("div", _hoisted_42, [
          _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t('components.diamonds.details.fullSpecs.dimension')) + ":", 1),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("span", _hoisted_45, _toDisplayString(__props.diamond.width.toLocaleString('de-DE')) + " x " + _toDisplayString(__props.diamond.length.toLocaleString('de-DE')) + " x " + _toDisplayString(__props.diamond.height.toLocaleString('de-DE')) + " " + _toDisplayString(_ctx.$t('components.diamonds.details.fullSpecs.unit_mm')), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_46, [
        _createElementVNode("div", _hoisted_47, [
          _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.$t('components.diamonds.details.fullSpecs.institute')) + ":", 1),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("span", _hoisted_50, _toDisplayString(__props.diamond.institute), 1),
            _createElementVNode("a", {
              href: _unref(Certificate).getUrl(__props.diamond.institute, __props.diamond.certificate),
              target: "_blank"
            }, [...(_cache[3] || (_cache[3] = [
              _createElementVNode("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                fill: "none",
                viewBox: "0 0 24 24",
                "stroke-width": "1.5",
                stroke: "currentColor",
                class: "size-5"
              }, [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  d: "M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                })
              ], -1)
            ]))], 8, _hoisted_51)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_52, [
      (isConfSession.value)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (addToConfSession())),
            class: "block w-full text-white bg-brand-main p-2 text-center hover:bg-white hover:text-brand-main border border-brand-main text-sm font-light"
          }, _toDisplayString(_ctx.$t("components.diamonds.details.DiamondDetailsNav.addToItem")), 1))
        : (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (openCatalog())),
            class: "block w-full text-white bg-brand-main p-2 text-center hover:bg-white hover:text-brand-main border border-brand-main text-sm font-light"
          }, _toDisplayString(_ctx.$t("components.diamonds.details.DiamondDetailsNav.addToItem")), 1)),
      (!isConfSession.value)
        ? (_openBlock(), _createElementBlock("form", _hoisted_53, [
            _createElementVNode("button", _hoisted_54, _toDisplayString(_ctx.$t("components.diamonds.details.head.button.buyJewelry")), 1),
            _cache[4] || (_cache[4] = _createElementVNode("input", {
              type: "hidden",
              name: "lang",
              value: "de"
            }, null, -1)),
            _cache[5] || (_cache[5] = _createElementVNode("input", {
              type: "hidden",
              name: "action",
              value: "order"
            }, null, -1)),
            _createElementVNode("input", {
              type: "hidden",
              name: "order",
              value: orderDataJewelry.value
            }, null, 8, _hoisted_55)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        onClick: goBack,
        class: "block w-full text-white bg-brand-main p-2 text-center hover:bg-white hover:text-brand-main border border-brand-main text-sm font-light"
      }, _toDisplayString(_ctx.$t("components.diamonds.details.DiamondDetailsNav.backToSearch")), 1)
    ])
  ]))
}
}

})